const e = "styles-module__menuWrapper___sXF1p", _ = "styles-module__accountLinkWrapper___JvtAZ", t = "styles-module__hoverMenu___w1BvT", n = "styles-module__forceOpen___HDu14", o = "styles-module__accountLabelTitle___v7JLs", s = "styles-module__chevronIcon___ML5cZ", c = "styles-module__scrolledHeader___hItmh", u = "styles-module__menuItem___MgBF4", l = "styles-module__menuItemText___onf1w", m = "styles-module__gradientText___wV4mZ", r = "styles-module__menuIcon___yJPNt", a = "styles-module__userImageContainer___7kyEE", d = "styles-module__userImage___SWgN0", i = "styles-module__notificationBadge___hGFsL", I = {
  menuWrapper: e,
  accountLinkWrapper: _,
  hoverMenu: t,
  forceOpen: n,
  accountLabelTitle: o,
  chevronIcon: s,
  scrolledHeader: c,
  menuItem: u,
  menuItemText: l,
  gradientText: m,
  menuIcon: r,
  userImageContainer: a,
  userImage: d,
  notificationBadge: i
};
export {
  o as accountLabelTitle,
  _ as accountLinkWrapper,
  s as chevronIcon,
  I as default,
  n as forceOpen,
  m as gradientText,
  t as hoverMenu,
  r as menuIcon,
  u as menuItem,
  l as menuItemText,
  e as menuWrapper,
  i as notificationBadge,
  c as scrolledHeader,
  d as userImage,
  a as userImageContainer
};
